import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { EnterOTP } from './otpVerify/otp.component';
import { IndexComponent } from './index/index.component';
import { AppRoutingModule } from './app.routing';
import { registerDataService } from './index/register-data.service';
import { otpDataService } from './otpVerify/otp-data.service';
import { HttpModule } from '@angular/http';
import { GlobalService } from './model/global.service';
import { ClaimReward } from './claimReward/claimReward';
import { ThankYou } from './thankYou/thankYou';
import { rewardDataService } from './claimReward/claim-data.service';

import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { RecaptchaModule, RecaptchaLoaderService } from 'ng-recaptcha';

import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { from } from 'rxjs/observable/from';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ChartsModule } from 'ng2-charts';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';


@NgModule({
  declarations: [
    AppComponent,
    EnterOTP,
    IndexComponent,
    ClaimReward,
    ThankYou
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    BrowserAnimationsModule,
    ChartsModule,
    Ng4LoadingSpinnerModule.forRoot()

  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  }, GlobalService, registerDataService, otpDataService, rewardDataService, RecaptchaLoaderService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts